import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { PrimengModule } from 'src/app/primeng/primeng.module';
import { MxInputSwitchComponent } from './mx.input-switch.component';

export const COMPONENTS: any[] = [
  MxInputSwitchComponent,
];

@NgModule({
  imports: [CommonModule, PrimengModule, FormsModule],
  declarations: [...COMPONENTS],
  exports: [...COMPONENTS],
})
export class MxInputSwitchModule {}
